import { onReady } from '../base/init.js';

// Доступная модалка: ESC, клик по фону, focus-trap, блокировка скролла body.
// Открытие: [data-modal-target="#id"], .js-show-modal/[data-modal] → дефолтная #modalCallback,
// и любые ссылки a[href="#callback"] (грейсфул-фолбэк: якорь к секции при отключённом JS).
onReady(() => {
  const modals = document.querySelectorAll('.js-modal');
  if (!modals.length) return;

  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let lastFocused = null;

  // Дефолтные заголовок/подзаголовок берём из разметки модалки — чтобы было к чему
  // вернуться, когда триггер не задаёт свой контекст.
  modals.forEach((modal) => {
    const titleEl = modal.querySelector('.modal__title');
    const subEl = modal.querySelector('.modal__subtitle');
    modal._defaultTitle = titleEl ? titleEl.textContent.trim() : '';
    modal._defaultSubtitle = subEl ? subEl.textContent.trim() : '';
  });

  // Подставляет в модалку контекст триггера: заголовок (явный data-modal-title →
  // текст кнопки → дефолт), подзаголовок и источник заявки (скрытое поле source).
  function applyContext(modal, trigger) {
    if (!modal) return;
    const titleEl = modal.querySelector('.modal__title');
    const subEl = modal.querySelector('.modal__subtitle');

    const title =
      (trigger && trigger.getAttribute('data-modal-title')) ||
      (trigger && trigger.textContent.trim()) ||
      modal._defaultTitle;
    const subtitle = (trigger && trigger.getAttribute('data-modal-subtitle')) || modal._defaultSubtitle;

    if (titleEl && title) titleEl.textContent = title;
    if (subEl) subEl.textContent = subtitle;

    // Источник заявки — чтобы лиды из разных CTA были различимы на бэкенде.
    const form = modal.querySelector('.js-form-callback');
    if (form) {
      const setHidden = (name, value) => {
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
      };

      setHidden('source', (trigger && trigger.getAttribute('data-modal-source')) || title || '');
      // Маршрут CallTouch конкретного ДЦ (карта/бургер). Пусто → бэкенд берёт дефолтный.
      setHidden('ct_route', (trigger && trigger.getAttribute('data-modal-ct-route')) || '');

      // Селектор ДЦ в форме стартует с маршрута триггера (кнопка конкретного центра
      // с карты/бургера), иначе — с первого центра списка. Выбор человека при отправке
      // главнее: _buildFormData перезапишет ct_route значением селектора.
      const dealerSelect = form.querySelector('select[name="dealer"]');
      if (dealerSelect && dealerSelect.options.length) {
        const route = (trigger && trigger.getAttribute('data-modal-ct-route')) || '';
        const known = [...dealerSelect.options].some((option) => option.value === route);
        dealerSelect.value = known ? route : dealerSelect.options[0].value;
      }
    }
  }

  function open(modal) {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    // Фокус — на контейнер диалога (tabindex=-1), а не на первый фокусируемый
    // элемент: иначе фокус попадал на кнопку закрытия и она подсвечивалась
    // (см. proposals/0018).
    const focusTarget = modal.querySelector('.modal__dialog') || modal.querySelector(FOCUSABLE);
    if (focusTarget) focusTarget.focus();
  }

  // Сброс success-экрана форм внутри модалки: иначе overlay «Спасибо» остаётся
  // в DOM и при повторном открытии показывается вместо формы.
  function resetForms(modal) {
    modal.querySelectorAll('.form-callback.is-success').forEach((form) => {
      form.classList.remove('is-success');
      const overlay = form.querySelector('.form-callback__success');
      if (overlay) overlay.remove();
    });
  }

  function close(modal) {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    resetForms(modal);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  // Закрытие: кнопки/оверлей
  modals.forEach((modal) => {
    modal.querySelectorAll('.js-modal-close').forEach((el) => {
      el.addEventListener('click', () => close(modal));
    });

    // Focus-trap
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        close(modal);
        return;
      }
      if (e.key !== 'Tab') return;
      const items = [...modal.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  });

  // Открытие формы обратной связи на самой странице: лид уходит в CallTouch через
  // /api/send (API Calltouch, маршрут по выбранному ДЦ), а не вызовом ОЗ-виджета.
  function openFormModal(trigger) {
    const target = trigger.getAttribute('data-modal-target') || trigger.getAttribute('data-modal') || '#modalCallback';
    const modal = document.getElementById(target.replace(/^#/, '')) || document.querySelector('.js-modal');
    applyContext(modal, trigger);
    open(modal);
  }

  // Триггеры открытия — встроенная модалка form-callback со своей формой
  // (телефон, выбор ДЦ, согласия).
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-target], [data-modal], .js-show-modal, a[href="#callback"]');
    if (!trigger) return;
    e.preventDefault();
    openFormModal(trigger);
  });
});
